import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-aac-tools',
  templateUrl: './aac-tools.component.html',
  styleUrls: ['./aac-tools.component.scss']
})
export class AacToolsComponent {
    constructor(private router: Router){}

    openAuthoringTools(){
      this.router.navigate(['ada-access/auth-tools'])
    }

    reporting(){
      this.router.navigate(['ada-access/reports'])
    }
}
